<template>
  <div class="economic-production-pavilion">
    <div class="chart-con has-tab">
      <div class="chart-pie">
        <v-chart ref="pie3D-chart-allLevelsMembersProportion" id="pie3D-chart-allLevelsMembersProportion" class="pie3D-chart"
                 v-show="tabIndex"
                 :options="chartOption" />
        <v-chart ref="pie-chart-provinceCocLevelSituationAnalysis" id="pie-chart-provinceCocLevelSituationAnalysis" class="pie-chart" :options="chartOption" />
        <div class="chart-legend">
          <div class="legend-list">
            <div class="legend-item" v-for="(item, i) in chartData" :key="i">
              <div class="name">
                <span class="color" :style="{ 'background-color': tabIndex ? colors3D[i] : colors[i] }"></span>
<!--                <el-tooltip effect="dark" placement="top" v-if="item.name && item.name.length > 6">-->
<!--                  <span>-->
<!--                    {{ item.name ? item.name : '-' }}-->
<!--                  </span>-->
<!--                  <div slot="content">-->
<!--                    {{ item.name ? item.name : '-' }}-->
<!--                  </div>-->
<!--                </el-tooltip>-->
                <span>
                  {{ item.name ? item.name : '-' }}
                </span>
              </div>
              <span class="num">
                {{ item.value }}
              </span>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import drawPie from '../chartJs/pie';
import drawPie3D from '../chartJs/pie3D';
import { getPieData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import echarts from 'echarts';
import ElementSelect from '../../../components/element-select';

const colors3D = ['#00c9ff', '#0078ff', '#fcf5c2','#58ecac','#ff8c60','#a280ff'];
const colors = [
  '#00c5fa',
  '#0078ff',
  '#fcf5c2',
  '#58ecac',
  '#ff8c60',
  '#a280ff',
  '#ee6566',
  '#fac959',
  '#91cd74',
  '#3aa272',
  '#aae6ff',
];
export default {
  name: 'allLevelsMembersProportion',
  components: { ElementSelect, TabList },
  props: {
    yearP: {
      type: Number,
      default: 2023,
    },
    selectListP: {
      // 列信息
      type: Array,
      default: () => {
        return [];
      },
    },
    searchData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showIndex:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      chartData: null,
      tabIndex: 0,

      colors,
      colors3D,
      year: this.yearP,
      selectList: [
        // {
        //   value: 2020,
        //   label: '2020',
        // },
        // {
        //   value: 2021,
        //   label: '2021',
        // },
        // {
        //   value: 2022,
        //   label: '2022',
        // },
        ...this.selectListP,
      ],
      // ],

      tabList: [
        {
          key: 0,
          label: '行业',
        },
        {
          key: 1,
          label: '产业',
        },
      ],
      pager: {
        current: 1,
        total: 2,
      },
      legendBox: null,
      chart: null,
      chartOption3D: null,
      chartOption: null,
    };
  },
  watch: {
    // tabIndex(n) {
    //   if (!n) {
    //     this.chart.off('click');
    //     this.chart.off('mouseover');
    //     this.chart.off('globalout');
    //   }
    //   this.chart = null;
    //   this.chartOption = null;
    //   this.chartOption3D = null;
    //   this.$nextTick(() => {
    //     this.getData();
    //   });
    // },
    // year(n) {
    //   this.$nextTick(() => {
    //     this.getData();
    //   });
    // },
    searchData(n) {
      this.chartData = n.slice();
      this.paintData()
    },
    showIndex(n) {
      console.log("bbbbbbbbbbbbbbbbbbbbbbbb", n)
      this.tabIndex = n;
    },
    'pager.current'(n) {
      if (n) {
        let box = this.legendBox;
        let y = box.clientHeight * (n - 1);
        console.log(box.clientHeight, n, y);
        box.style.transform = `translateY(-${y > 0 ? y + 15 : y}px)`;
      }
    },
  },
  methods: {
    changePage(next) {
      let { current, total } = this.pager;
      if (next) {
        this.pager.current = current < total ? current + 1 : current;
      } else {
        this.pager.current = current > 1 ? current - 1 : current;
      }
    },
    paintData() {
      this.chart = echarts.init(document.getElementById('pie-chart-provinceCocLevelSituationAnalysis'));
      this.$nextTick(() => {
        this.setInterData();
      });

    },
    getData() {
      this.chart = echarts.init(document.getElementById('pie-chart-provinceCocLevelSituationAnalysis'));
      this.$api.screen
        .getGDPPrivateEconomy({
          caliber: this.tabList[this.tabIndex].label,
          year: this.year,
        })
        .then((res) => {
          let { data } = res.data;
          if (data?.length) {
            let list = data.map((item) => {
              return {
                name: item.quotaName,
                value: item.total,
              };
            });
            this.chartData = list;
            this.$nextTick(() => {
              this.setInterData();
            });
          } else {
            this.selectList = this.selectList.filter((x) => x.value !== this.year);
            this.year = this.selectList[0].value;
          }
        });

      // getPieData().then(res => {
      //   let type = this.tabList[this.tabIndex].label;
      //   let data = res.RECORDS.filter(item => {
      //     return item['类型'] === type && item['年份'] == this.year;
      //   });
      //   console.log(data, '-')
      //   let list = data.map(item => {
      //     return {
      //       name: item['指标'],
      //       value: Number(item['总数'])
      //     }
      //   });
      //   this.chartData = list;
      //   this.$nextTick(() => {
      //     this.setInterData();
      //   })
      // })
    },
    setInterData() {
      this.$nextTick(() => {
        let refName = 'pie-chart-provinceCocLevelSituationAnalysis';
        this.$refs[refName].clear();
        this.chartOption = drawPie(this.chartData, colors);
      });
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.getData();
    //   let box = $('.legend-list');
    //   this.legendBox = box[0];
    // });
  },
};
</script>

<style lang="less" scoped>
.economic-production-pavilion {
  .chart-box();
  height: 370px;
  width: 100%;

  /deep/ .tab-list {
    .tab-item {
      min-width: 60px !important;
    }
  }

  .chart-con {
    overflow: inherit;
  }

  .pie-bg {
    width: 490px;
    height: 298px;
    background: url('~img/home/pie-bg.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: -45px;
    bottom: -5px;
    /*z-index: 2;*/
  }

  .chart-pie {
    display: flex;
  }

  #pie-chart-provinceCocLevelSituationAnalysis,
  #pie3D-chart-allLevelsMembersProportion {
    width: 465px;
    height: 380px;
    //margin-top: -20px;
    margin-top: 10px;
  }

  .chart-legend {
    width: calc(100% - 245px);
    /*width: 50%;*/
    color: #fff;
    height: 350px;
    //padding-right: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    max-height: 350px;
    overflow: hidden;
    margin-left: -15px;
    //.show-scroll-bg-trans();

    &.chart3d {
      justify-content: center;
      max-height: 350px;

      .legend-item {
        line-height: 30px;
        //margin-bottom: 20px;
      }
    }

    .legend-list {
      width: 400px;
      height: calc(100% - 20px);
      transition: all 0.3s;
      padding-top: 20px;
    }

    .pager-box {
      position: absolute;
      right: 0;
      bottom: 10px;
      .flex-center();
      padding-right: 10px;
      font-size: 12px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #87e6ff;
      line-height: 38px;

      div {
        letter-spacing: -2px;
        margin: 0 10px;

        span {
          color: rgba(135, 230, 255, 0.3);
        }
      }

      i {
        margin-top: 2px;
        cursor: pointer;

        &.dis {
          color: rgba(135, 230, 255, 0.3);
          cursor: not-allowed;
        }
      }
    }

    .legend-item {
      .flex-center();
      //flex-direction: column;
      font-size: 23px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #dcdcdc;
      /*line-height: 20px;*/
      margin-bottom: 10px;
      width: 400px;
      align-items: flex-start;

      &:first-child {
        //margin-top: 10px;
      }

      .name {
        width: 500px;
        .flex-center();

        span:last-child {
          width: calc(100% - 21px);
          .ellipsis();
        }
      }
    }

    .color {
      width: 15px;
      height: 11px;
      margin-right: 6px;
    }

    .num {
      width: 150px;
      font-size: 25px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #fff;
      line-height: 30px;
      margin: 0 5px 0 20px;
      //text-align: right;
    }

    .unit {
      font-size: 20px;
    }
  }
}
</style>
